import React, { Component } from 'react';
import { API_ENDPOINT } from '../../../constants';
import ListBuilder from '../../../components/listBuilder';
import Isvg from 'react-inlinesvg';
import deleteIcon from '../../../assets/svg/garbage.svg';
import editIcon from '../../../assets/svg/edit.svg';
import addIcon from '../../../assets/svg/add-icon.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import FormBuilder from '../../../components/forms/modalFormBuilder';
import { minValueAndRequired, minValueV2, required } from '../../../components/forms/validation';
import DeleteModal from '../../../components/deleteModal';
import {
	updateParamsHelper,
	getParamsFromURL,
	parseJSON,
} from '../../../helpers/custom.helper';
import PreviewModal from '../../../components/previewModal';
import ErrorModal from '../../../components/errorModal';


export default class VaccinationsTab extends Component {
	constructor(props) {
		super(props);
		this.state = {
			form: false,
			preview: false,
			total: 0,
			params: {
				entries: 10,
				page: 0,
				sortField: 'tsCreatedAt',
				sortType: -1,
				filter: '',
			},
			filter: null,
			loading: true,
			vaccinations: [],
			error: null,
			modified: 'Not modified'.translate(this.props.lang),
			deleteVaccination: null,
			isConsentActive: false,
		};
	}

	get = async () => {
		this.setState({
			loading: true,
			vaccinations: [],
			modified: 'Not modified'.translate(this.props.lang),
		});

		try {
			// fetch(API_ENDPOINT + `/users/users/patient/journal-system/has-consent/${this.props.patientId}/${this.props._groupId}`, {
			// 	method: 'GET',
			// 	headers: {
			// 		'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
			// 		'content-type': 'application/json'
			// 	},
			// }).then(res => res.json()).then((result) => {
			// 	if (result.success) {
			// 		this.setState({
			// 			isConsentActive: true
			// 		})
			// 	} else {
			// 		this.setState({
			// 			isConsentActive: false
			// 		})
			// 	}
			// })

			const response = await fetch(
				`${API_ENDPOINT}/users/users/patient/patientVaccinations/get`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${localStorage.getItem('authToken')}`,
					},
					body: JSON.stringify({
						groupAlias: localStorage.getItem('groupAlias'),
						groupId: this.props._groupId || null,
						patientId: this.props.patientId,
						total: this.state.total,
						entries: this.state.params?.entries,
						page: this.state.params?.page,
						sortField: this.state.params?.sortField,
						sortType: this.state.params?.sortType,
						filter: this.state.params?.filter,
						isConsentGrantedAndActive: this.props.isConsentGrantedAndActive
					}),
				}
			);

			const data = await response.json();

			if (data.items) {
				const newState = {
					loading: false,
					vaccinations: data.items,
					total: data.total,
				};

				if (data.tsModified) {
					const modified = this.props.getStringDateTs?.(
						data.tsModified,
						this.props.dateFormat
					);
					if (modified) newState.modified = modified.translate(this.props.lang);
				}

				this.setState(newState);
			} else {
				const errState = {
					loading: false,
					modified: 'Not modified'.translate(this.props.lang),
				};

				if (data.error) {
					errState.error = data.error;
				}

				this.setState(errState);
			}
		} catch (err) {
			this.setState({
				loading: false,
				error: err?.message || 'Error fetching vaccinations',
			});
		}
	};

	getClinicUserData = async () => {
		try {
			const response = await fetch(`${API_ENDPOINT}/journal-curoflow/clinic-user/get-permission`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${localStorage.getItem('authToken')}`,
				},
				body: JSON.stringify({ groupId: this.props._groupId }),
			});

			const result = await response.json();

			this.setState({ clinicUserPermissions: result?.data?.permissions });
		} catch (err) {
			console.log('Err get clinic user data', err);
		}

	}

	componentDidMount() {
		this.getClinicUserData();

		const urlParams = getParamsFromURL();

		const newParams = {
			...this.state.params,
			entries: urlParams.entries,
			filter: urlParams.filter,
		};

		this.setState({ params: newParams }, () => {
			if (this.props.vaccinations) {
				this.setState({
					loading: false,
					vaccinations: this.props.vaccinations,
				});
			} else {
				this.get();
			}
		});
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.patientId !== this.props.patientId ||
			prevProps._groupId !== this.props._groupId ||
			prevProps.view !== this.props.view
		) {
			this.setState({
				loading: true,
				vaccinations: [],
				modified: 'Not modified'.translate(this.props.lang),
			});

			this.get();
		}

		if (this.props.isConsentGrantedAndActive !== prevProps.isConsentGrantedAndActive) {
			this.get();
		}
	}

	// always copy - paste these updateSort, updateParams, updateMultipleParams
	updateSort = (field, type) => {
		updateParamsHelper(this, { sortField: field, sortType: type });
	};

	updateParams = (name, value, restart = false) => {
		updateParamsHelper(this, { [name]: value }, restart);
	};

	updateMultipleParams = (fields, restart = false) => {
		updateParamsHelper(this, fields, restart);
	};

	insertOrUpdate = (data) => {
		const id = data._id ?? 'new';

		const vaccination = {
			vaccine: data.vaccine,
			// targetDisease: data.targetDisease,
			batchNumber: data.batchNumber,
			doseNumber: data.doseNumber,
			totalDoses: data.totalDoses,
			administrationDate: data.administrationDate,
			administeredAt: data.administeredAt,
			administeredBy: data.administeredBy,
			administrationRoute: data.administrationRoute,
			administrationSite: data.administrationSite,
			notes: data.notes,
		};

		const body = {
			groupId: this.props._groupId,
			patientId: this.props.patientId,
			vaccination,
		};

		fetch(API_ENDPOINT + '/users/users/patient/patientVaccinations/' + id, {
			method: id === 'new' ? 'POST' : 'PUT',
			headers: {
				Authorization:
					typeof localStorage !== 'undefined'
						? `Bearer ${localStorage.getItem('authToken')}`
						: null,
				'content-type': 'application/json',
			},
			body: JSON.stringify(body),
		})
			.then(parseJSON)
			.then(({ result, status }) => {
				if (result.error) {
					this.setState({ error: result.error });
				} else {
					this.get();
					this.setState({
						form: false,
					});
				}
			});
	};

	delete = (data) => {
		this.setState(
			{
				loading: true,
			},
			() => {
				fetch(
					API_ENDPOINT + '/users/users/patient/patientVaccinations/' + data._id,
					{
						method: 'DELETE',
						headers: {
							Authorization:
								typeof localStorage !== 'undefined'
									? `Bearer ${localStorage.getItem('authToken')}`
									: null,
							'content-type': 'application/json',
						},
					}
				)
					.then(parseJSON)
					.then(({ result, status }) => {
						if (result.error) {
							this.setState({ error: result.error });
						}
						this.get();
					});
			}
		);
	};

	render() {
		let params = this.state.params;

		return (
			<>

				<div className='panel-header'>
					<h5 className='component-header'>
						{'Vaccinations'.translate(this.props.lang)}
					</h5>
					<button
						className='btn add-button'
						onClick={() => {
							this.setState({
								form: true,
							});
						}}
					>
						<Isvg src={addIcon} /> {'Add'.translate(this.props.lang)}
					</button>
				</div>

				<ListBuilder
					lang={this.props.lang}
					loading={this.state.loading}
					total={this.state.total}
					hideEntries={false}
					showNumeration={false}
					hideFilters={true}
					fields={[

						{
							type: 'text',
							name: 'vaccine',
							label: 'Vaccine'.translate(this.props.lang),
						},
						{
							type: 'count-of-total',
							label: 'Dose'.translate(this.props.lang),
							firstNumberInputName: 'doseNumber',
							secondNumberInputName: 'totalDoses'
						},
						{
							type: 'text',
							name: 'batchNumber',
							label: 'Batch number'.translate(this.props.lang),
						},
						{
							type: 'text',
							name: 'administrationSite',
							label: 'Vaccination site'.translate(this.props.lang),
						},
						{
							type: 'text',
							label: 'Administered'.translate(this.props.lang),
							name: 'administeredInfo'
						}

					]}
					items={this.state.vaccinations.map((item) => {
						return {
							...item,
							___className: item?.isDeleted ? 'journal-tab-item-delete' : '',
							administeredInfo: (
								<div>
									{item.administeredBy && (
										<div>
											<span>{item.administeredBy}</span>
										</div>
									)}

									{item.administeredAt && (
										<div>
											<span>{item.administeredAt}</span>
										</div>
									)}

									{item.administrationDate && (
										<div>
											<span>{'Administration date'.translate(this.props.lang)}:</span>{' '}
											<span>{item.administrationDate}</span>
										</div>
									)}
								</div>
							),

						};
					})}
					actions={this.props.isConsentGrantedAndActive && this.state.isConsentActive ? [] : [
						{
							renderComponent: (item) =>
								item?.isDeleted ? (
									<div className="deleted-badge">
										{'Deleted'.translate(this.props.lang)}
									</div>
								) : null,
							onClick: (item) => { },
						},
						// {
						// 	component: (
						// 		<div className='tabel-action-tooltip'>
						// 			{' '}
						// 			<Isvg src={infoIcon} className='journal-info-icon' />
						// 			<div className='chat-icons-tooltip'>
						// 				{'Notes'.translate(this.props.lang)}
						// 			</div>{' '}
						// 		</div>
						// 	),
						// 	onClick: (item) => {
						// 		this.setState({ preview: item });
						// 	},
						// },
						{

							component: (
								<div className='tabel-action-tooltip'>
									{' '}
									<Isvg src={editIcon} />{' '}
									<div className='chat-icons-tooltip'>
										{'Edit'.translate(this.props.lang)}
									</div>{' '}
								</div>
							),
							onClick: (item) => {
								this.setState({ form: item });
							},
							condition: (item) => {
								const hasPermission = this.state.clinicUserPermissions?.write?.patient_vaccination;
								return hasPermission && item && !item.isDeleted;
							}
						},
						{
							component: (
								<div className='tabel-action-tooltip'>
									{' '}
									<Isvg src={deleteIcon} />{' '}
									<div className='chat-icons-tooltip'>
										{'Delete'.translate(this.props.lang)}
									</div>{' '}
								</div>
							),
							onClick: (item) => {
								this.setState({ deleteVaccination: item });
							},
							condition: (item) => {
								const hasPermission = this.state.clinicUserPermissions?.write?.patient_vaccination;
								return hasPermission && item && !item.isDeleted;
							}
						},
					]}
					rawItems={this.state.items}
					params={params}
					sortField={params.sortField}
					sortType={params.sortType}
					updateSort={this.updateSort}
					updateParams={this.updateParams}
					updateMultipleParams={this.updateMultipleParams}
				></ListBuilder>

				{/* Preview */}
				<PreviewModal
					lang={this.props.lang}
					isOpen={this.state.preview}
					toggle={() => this.setState({ preview: false })}
					title={'Notes'.translate(this.props.lang)}
				>
					{this.state.preview?.notes || "-"}
				</PreviewModal>

				{/* Delete */}
				<DeleteModal
					lang={this.props.lang}
					isOpen={this.state.deleteVaccination}
					toggle={() => this.setState({ deleteVaccination: null })}
					handler={() => {
						this.delete(this.state.deleteVaccination);
						this.state.deleteVaccination = null;
					}}
				>
					{'Delete this vaccination'.translate(this.props.lang)}?
				</DeleteModal>

				{/* Error */}
				<ErrorModal
					lang={this.props.lang}
					isOpen={this.state.error}
					toggle={() => this.setState({ error: null })}
				>
					{this.state.error}
				</ErrorModal>

				{/*  Insert / Update */}
				{this.state.form ? (
					<FormBuilder
						selectedGroup={this.props.selectedGroup}
						selectedClinic={this.props.selectedClinic}
						lang={this.props.lang}
						onSubmit={(data) => {
							this.insertOrUpdate(data);
						}}
						initialValues={this.state.form}
						size='xl'
						isOpen={this.state.form}
						toggle={() =>
							this.setState({ form: null, doctorPermissions: false })
						}
						title={
							this.state.form._id
								? 'Edit vaccination'.translate(this.props.lang)
								: 'Add new vaccination'.translate(this.props.lang)
						}
						buttonText={'Save'
							.translate(this.props.lang)}
						disabledCreatedInfo={true}
						fields={[
							{
								type: 'row',
								children: [
									{
										type: 'col',
										width: {
											lg: 12,
											sm: 12,
											xs: 12,
										},
										children: [
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 12,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'combo-box',
																name: 'vaccine',
																label: 'Vaccine'.translate(this.props.lang),
																validate: required('Vaccine is required!'.translate(this.props.lang)),
																placeholder: 'e.g COVID-19 Vaccine (CV19)'.translate(this.props.lang),
																options: [],
																optionsFetch: {
																	url: API_ENDPOINT + "/users/users/patient/patientVaccinations/vaccine",
																	transformer: (items) => items.map(item => ({ label: item.name, value: item.name }))
																}
															}
														]
													},
												],
											},
										],
									},
									{
										type: 'col',
										width: {
											lg: 6,
											sm: 12,
											xs: 12,
										},
										children: [
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 6,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'doseNumber',
																label: 'Dose number'.translate(this.props.lang),
																placeholder: 'e.g 1'.translate(this.props.lang),
																validate: minValueAndRequired(
																	1,
																	'Dose number must be at least 1'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 6,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'totalDoses',
																label: 'Total doses'.translate(this.props.lang),
																placeholder: 'e.g 3'.translate(this.props.lang),
																validate: minValueAndRequired(
																	1,
																	'Total doses must be at least 1'.translate(
																		this.props.lang
																	)
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 12,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'text',
																name: 'administeredBy',
																label: 'Administered by'.translate(
																	this.props.lang
																),
																placeholder: 'e.g Dr. John Smith'.translate(this.props.lang),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 12,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'text',
																name: 'administrationRoute',
																label: 'Administration route'.translate(
																	this.props.lang
																),
																placeholder: 'e.g Intramuscular'.translate(this.props.lang),
															},
														],
													},
												],
											},
										],
									},
									{
										type: 'col',
										width: {
											lg: 6,
											sm: 12,
											xs: 12,
										},
										children: [
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 6,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'number',
																name: 'batchNumber',
																placeholder: 'Lot number'.translate(this.props.lang),
																label: 'Batch number'.translate(
																	this.props.lang
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 6,
															sm: 6,
															xs: 12,
														},
														children: [
															{
																type: 'date',
																name: 'administrationDate',
																label: 'Administration date'.translate(
																	this.props.lang
																),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 12,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'text',
																name: 'administeredAt',
																label: 'Administered at'.translate(
																	this.props.lang
																),
																placeholder: 'e.g City Health Clinic'.translate(this.props.lang),
															},
														],
													},
													{
														type: 'col',
														width: {
															lg: 12,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'text',
																name: 'administrationSite',
																label: 'Administration site'.translate(
																	this.props.lang
																),
																placeholder: 'e.g Left Arm'.translate(this.props.lang),
															},
														],
													},
												],
											},
										],
									},

									{
										type: 'col',
										width: {
											lg: 12,
											sm: 12,
											xs: 12,
										},
										children: [
											{
												type: 'row',
												children: [
													{
														type: 'col',
														width: {
															lg: 12,
															sm: 12,
															xs: 12,
														},
														children: [
															{
																type: 'textarea',
																name: 'notes',
																height: 100,
																label: 'Notes'.translate(this.props.lang),
															},
														],
													},
												],
											},
										],
									},
								],
							},
						]}
					></FormBuilder>
				) : null}
			</>
		);
	}
}
